import BlockMarkdownPluginFactory from '../Blocks/BlockMarkdownPluginFactory';
import CodeBlockComponentPlugin from './CodeBlockComponentPlugin';

const CodeBlockMarkdownPlugin = BlockMarkdownPluginFactory({
  type: 'code',
  shortcuts: ['``'],
  triggerCharacters: ['`'],
  dependencies: [CodeBlockComponentPlugin],
});

export default CodeBlockMarkdownPlugin;
